<template>
  <div class="container">
    <div class="dashboard columns scene-editor">
      <div class="column column-55">
        <div v-if="!isLoading"
          class="scene-editor-wrap">
          <div
            :class="{ columnBody: true, isHome: currentScene && currentScene.type === 'home', dropzone: true, subsceneEdit: selectedScene && selectedScene.type === 'subscene' }"
            ref="refDropzone"
          >
            <div v-if="isLoading">
              <p>Loading...</p>
            </div>
            <div class="preview-scene" v-if="!isLoading && selectedScene">
              <InfographicsPreview :scene="isUnsaved(selectedScene._id) ? isUnsaved(selectedScene._id) : selectedScene" />
            </div>
          </div>
          <div class="preview-scene__actions">
            <button class="button button-back" for="scene-textbox" @click="handleBack()">Back</button>
            <button class="button" for="scene-textbox" :disabled="!isUnsaved(selectedScene._id)" @click="saveScene()">Save</button>
          </div>
        </div>
        <SceneInfo v-if="selectedProject && getSelectedScene" :scene="currentScene" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import { initDropzone, initDraggable, getProjectScenes } from "../../utils";

// import DraggableMark from "../../components/Dashboard/DraggableMark";
import AddMarkPopup from "../../components/Dashboard/Popups/AddMark";
import AddMediaPopup from "../../components/Dashboard/Popups/AddMedia";
import SceneInfo from "../../components/Dashboard/SceneInfo";
import InfographicsPreview from "./InfographicsPreview";

import api from "../../api";

export default {
  data() {
    return {
      isLoading: true,
      imageIsLoaded: false
    };
  },
  computed: {
    ...mapState(["selectedScene", "selectedProject", "lang", "unsavedScenes", "selectedMark"]),
    ...mapGetters(["getSelectedScene", "getSelectedProject"]),
    currentScene() {
      const unsaved = this.unsavedScenes.find(
        s => s._id === this.selectedScene._id
      );

      return unsaved || this.selectedScene;
    },
    getSceneBigImage() {
      return this.isLoading
        ? null
        : this.selectedScene.imageBig
        ? this.selectedScene.imageBig
        : this.selectedProject.preview;
    },
    scenes() {
      if (this.selectedScene.id === "home") {
        return this.getSelectedProject.scenes.filter(s => s.type === "scene");
      } else if (
        this.selectedScene.type === "scene" &&
        this.selectedScene.subscenes.length > 0
      ) {
        return this.getSelectedScene.subscenes;
      } else {
        return [];
      }
    }
  },
  methods: {
    ...mapMutations([
      "setSelectedProject",
      "setSelectedScene",
      "changeScene",
      "saveLocalScene",
      "saveUnsavedScene",
      "setSelectedMark"
    ]),
    isUnsaved(id) {
      return this.unsavedScenes.find(s => s._id === id);
    },
    handleBack: function() {
      this.setSelectedMark(null);
      this.$router.back();
    },
    saveScene: function() {
      // eslint-disable-next-line
      this.setSelectedScene(this.currentScene);
      this.saveUnsavedScene(this.currentScene._id);

      api.projects
        .updateProject(this.selectedProject._id, this.selectedProject)
        .then(response => {
          console.log(response);
        })
        .catch(function(error) {
          // handle error
          console.log(error);
        });
    }
  },
  mounted: function() {
    this.isLoading = true;

    api.projects.loadProjectById(this.$route.params.id).then(project => {
      const scenes = project.data.scenes.filter(
        scene => scene.type === "scene"
      );

      const scene = getProjectScenes(project.data).find(
        v => v._id === this.$route.params.sid
      );

      this.setSelectedProject(project.data);
      this.setSelectedScene(scene);

      this.isLoading = false;

      this.$nextTick(() => {
        if (this.$refs.sceneImage) {
          this.$refs.sceneImage.onload = () => {
            this.imageIsLoaded = true;
          };
        }
      });
    });

    initDropzone(".dropzone", this, false, element => {
      const id = element.getAttribute("data-id");
      const x = element.getAttribute("data-x");
      const y = element.getAttribute("data-y");

      this.changeScene({
        id,
        update: {
          pos: {
            x,
            y
          }
        }
      });

      initDraggable(element, ev => {
        // eslint-disable-next-line
        console.log(ev);
        this.saveLocalScene(this.selectedScene);
      });
    });
  },
  components: {
    // DraggableMark,
    SceneInfo,
    InfographicsPreview
  }
};
</script>

<style lang="scss">
.scene-img {
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.assigned-scenes {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.scene-editor {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;

  // .column-55 {
  //   width: auto;
  // }
  &-wrap {
    position: relative;
  }

  .column-body {
    position: relative;
    max-width: 100%;
    min-width: 1920px;
    height: 845px;
    border: 1px solid #ddd;

    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.subsceneEdit {
  max-width: none;
  min-width: auto;
}

.columnBody.dropzone {
  position: relative;
  border: 1px solid #ddd;
  // max-width: 650px;
  margin: auto;

  &.isHome {
    // min-height: 1080px;
    width: 100%;
    max-width: none;
  }
}

.scene-marks {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.preview-scene {
  position: relative;

  &__actions {
    position: absolute;
    left: calc(100% + 20px);
    bottom: 0;
    display: flex;
    flex-direction: column;

    .button-back {
      margin-bottom: 20px;

      @media screen and (max-width: 1460px) {
        margin-bottom: 0;
      }
    }

    @media screen and (max-width: 1460px) {
      position: static;
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;
      margin-top: 20px;
    }
  }
}
</style>
